import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to element matching location.hash whenever the location changes.
 * If no hash, scrolls window to top on route change.
 */
const HashScroll = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait one tick for the new route's DOM to render
      const id = hash.replace('#', '');
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (attempt < 10) {
          setTimeout(() => tryScroll(attempt + 1), 50);
        }
      };
      tryScroll();
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    }
  }, [pathname, hash]);

  return null;
};

export default HashScroll;
